import { useEffect, useState } from 'react';
import _ from 'lodash';
import Icon from 'components/base/Icon';
import { Flex, Margin, WhiteSection } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { HyperLink } from 'components/base/HyperLink';
import Table from 'components/base/Table';
import { LINE_HEIGHT, SPACES } from 'common/constants/sizes';
import * as LighthouseService from 'common/services/lighthouse.service';
import { TableWrapper } from '../ChatTools/common';
import { useNotifications } from './hooks/useNotifications';
import {
  getTableData,
  getTableColumns,
  mergedPrReq,
  notificationPredictionType,
  getNotificationsByType
} from './notifications.service';
import { redirectToTeamGoals } from 'common/utils/utils';
import useLocationHighlightId from 'components/hooks/useLocationHighlightId';
import { useNotificationPrediction } from './hooks/useNotificationPrediction';
import { getPullRequestsSearchSummary } from 'common/services/pull-requests.service';
import useSettingsService from 'components/hooks/useSettingsService';
import { useHistory } from 'react-router';
import { LBButton } from '@linearb/buzz';

function Notifications({ currentTeams, toggleModal, toggleSnackBar, uiState }) {
  const history = useHistory();
  const selectedTeamId = _.get(uiState, 'selectedTeamId', null);
  const selectedTeamObj = _.find(
    currentTeams,
    ({ id }) => id === selectedTeamId
  );
  const { updateSetting, getTeamOrOrgSetting } = useSettingsService();

  const highlightWidgetId = useLocationHighlightId();

  const {
    notifications,
    setNotifications,
    NOTIFICATIONS_BUILDER,
    teamDashboard = [],
    setTeamDashboard
  } = useNotifications({
    selectedTeamId
  });
  const { teamDashboardId, teamDashboardWidgets = [] } = teamDashboard;

  const [prMerged, setPrMerged] = useState([]);
  const [predictionCount, setPredictionCount] = useState({});

  // notifications of prs type

  const prNotifications = getNotificationsByType(
    notifications,
    NOTIFICATIONS_BUILDER,
    notificationPredictionType.PRS
  );

  const { predictionsCount: predictionsCountPrs } = useNotificationPrediction({
    selectedTeamId,
    notifications: prNotifications,
    NOTIFICATIONS_BUILDER,
    notificationThresholds: null,
    prMerged
  });

  // notifications of branches type

  const branchesNotifications = getNotificationsByType(
    notifications,
    NOTIFICATIONS_BUILDER,
    notificationPredictionType.BRANCHES
  );

  const { predictionsCount: predictionsCountBranches } =
    useNotificationPrediction({
      selectedTeamId,
      notifications: branchesNotifications,
      NOTIFICATIONS_BUILDER,
      notificationThresholds: null,
      prMerged
    });

  useEffect(() => {
    const predictionCountByKey = _.keyBy(
      [...predictionsCountPrs, ...predictionsCountBranches],
      'notificationKey'
    );
    setPredictionCount(predictionCountByKey);
  }, [predictionsCountBranches, predictionsCountPrs]);

  const tableData = getTableData(
    notifications,
    teamDashboard,
    setNotifications,
    setTeamDashboard,
    teamDashboardWidgets,
    NOTIFICATIONS_BUILDER,
    updateSetting,
    getTeamOrOrgSetting,
    selectedTeamId,
    history,
    toggleModal,
    toggleSnackBar,
    teamDashboardId,
    highlightWidgetId,
    predictionCount,
    prMerged,
    setPredictionCount
  );

  useEffect(() => {
    // Fetch all PR merged for Org
    const getMergedPR = async () => {
      try {
        const res = await getPullRequestsSearchSummary(mergedPrReq);
        setPrMerged(res);
      } catch (e) {}
    };
    getMergedPR();
  }, []);

  const tableColumns = getTableColumns(teamDashboardId);

  return (
    <WhiteSection t={SPACES['x-medium']}>
      <Text
        size='large'
        weight='500'
        textTransform='uppercase'
        pb={SPACES.small}
      >
        Goals settings
      </Text>
      <Text
        size='medium'
        color='shuttleGray'
        pb={SPACES.small}
        lineHeight={LINE_HEIGHT.medium}
      >
        Use LinearB Goals to track your improvement over time and notify your
        team of potential issues.
        <br />
        Customize each goal. Your team can be notified via Slack or Teams each
        time a goal is at risk.
      </Text>
      <Flex direction='columns' items='center' pb='normal'>
        <HyperLink
          size='medium'
          onClick={() => LighthouseService.navigateArticle('93hjd4drzc')}
        >
          what are goals?
        </HyperLink>
      </Flex>
      <Margin b='medium'>
        {teamDashboardId && selectedTeamObj && (
          <LBButton
            onClick={() =>
              redirectToTeamGoals(history, selectedTeamObj, teamDashboardId)
            }
          >
            <Icon name='BarChart' color='white' /> View Goals dashboard
          </LBButton>
        )}
      </Margin>
      {tableData && (
        <TableWrapper>
          <Table columns={tableColumns} data={tableData} />
        </TableWrapper>
      )}
    </WhiteSection>
  );
}

export default Notifications;
